/* eslint-disable @typescript-eslint/no-explicit-any */

import useCreate from "@/hooks/use-create";
import { UseLoadingReturn } from "@/hooks/use-loading";
import productImageService from "@/services/product-images.service";
import { RequestsProps } from "@/types/requests.types";

export type CreateProductImageProps = {
  formData: FormData;
} & RequestsProps;

export type UseCreateProductImageReturn = {
  create: (props: CreateProductImageProps) => Promise<any | void>;
} & UseLoadingReturn;

const useCreateProductImage = (): UseCreateProductImageReturn => {
  const { isLoading, startLoading, endLoading, loadingIcon, create } = useCreate<FormData>({
    operation: (formData) => productImageService.create(formData),
  });
  const createProductImageWithResult = async (props: CreateProductImageProps): Promise<any> => {
    const imageResult = await create(props);
    return imageResult;
  };

  return {
    isLoading,
    startLoading,
    endLoading,
    loadingIcon,
    create: createProductImageWithResult,
  };
};

export default useCreateProductImage;
